import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ListIcon, BriefcaseIcon, UserCheckIcon, FileTextIcon, EyeIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Module } from '../data/courseData';
const iconMap: Record<string, ComponentType<{
  className?: string;
}>> = {
  list: ListIcon,
  briefcase: BriefcaseIcon,
  'user-check': UserCheckIcon,
  'file-text': FileTextIcon,
  eye: EyeIcon,
  'check-circle': CheckCircleIcon
};
interface ModuleCardProps {
  module: Module;
  index: number;
  courseId?: string;
}
export function ModuleCard({
  module,
  index,
  courseId
}: ModuleCardProps) {
  const Icon = iconMap[module.icon] || ListIcon;
  const linkPath = courseId ? `/curs/${courseId}/modul/${module.id}` : `/modul/${module.id}`;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.1
  }} data-id="element-1954">
      <Link to={linkPath} data-id="element-1955">
        <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100 h-full" data-id="element-1956">
          <div className="flex items-start space-x-4" data-id="element-1957">
            <div className="flex-shrink-0 w-12 h-12 bg-[#357BEB] bg-opacity-10 rounded-xl flex items-center justify-center" data-id="element-1958">
              <Icon className="w-6 h-6 text-[#357BEB]" data-id="element-1959" />
            </div>
            <div className="flex-1" data-id="element-1960">
              <h3 className="text-xl font-bold text-[#132C53] mb-2" data-id="element-1961">
                {module.title}
              </h3>
              <p className="text-gray-600 text-sm mb-4" data-id="element-1962">{module.description}</p>
              <div className="flex items-center justify-between" data-id="element-1963">
                <span className="text-sm text-gray-500" data-id="element-1964">
                  {module.lessons.length} lecții
                </span>
                <div className="flex items-center space-x-1 text-[#357BEB] font-medium text-sm" data-id="element-1965">
                  <span data-id="element-1966">Deschide modul</span>
                  <ArrowRightIcon className="w-4 h-4" data-id="element-1967" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>;
}